import * as React from "react";
import type { SVGProps } from "react";

const VehicleBus = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6683 12.6692H4.33194C3.59496 12.6692 2.99805 12.0722 2.99805 11.3353V3.99888C2.99805 2.89375 3.89375 1.99805 4.99888 1.99805H11.0014C12.1065 1.99805 13.0022 2.89375 13.0022 3.99888V11.3353C13.0022 12.0722 12.4053 12.6692 11.6683 12.6692Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M4.99902 10.6684H5.66597"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M10.335 10.6684H11.0019"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M5.49009 12.6694V13.6698C5.49009 14.0379 5.1913 14.3367 4.82315 14.3367H4.1562C3.78805 14.3367 3.48926 14.0379 3.48926 13.6698V12.3652"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.5116 12.3652V13.6698C12.5116 14.0379 12.2128 14.3367 11.8446 14.3367H11.1777C10.8095 14.3367 10.5107 14.0379 10.5107 13.6698V12.6694"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M13.002 4.66602H14.0024C14.3705 4.66602 14.6693 4.96481 14.6693 5.33296V7.33379"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M2.99842 4.66602H1.998C1.62985 4.66602 1.33105 4.96481 1.33105 5.33296V7.33379"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M12.2389 2.42809L11.0591 3.60792C10.809 3.85802 10.4695 3.99875 10.1161 3.99875H5.88496C5.53148 3.99875 5.19201 3.85802 4.9419 3.60792L3.76074 2.42676"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
    <path
      d="M13.0022 8.66746H2.99805"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
));
VehicleBus.displayName = "VehicleBus";

export default VehicleBus;
